import PropTypes from 'prop-types';

export const CalculatorResult = PropTypes.shape({
  id: PropTypes.number,
  email: PropTypes.string,
  city: PropTypes.string,
  country: PropTypes.string,
  state: PropTypes.string,
  zipcode: PropTypes.string,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string,
  result_transport_total: PropTypes.number,
  result_housing_total: PropTypes.number,
  result_food_total: PropTypes.number,
  result_goods_total: PropTypes.number,
  result_services_total: PropTypes.number,
  result_grand_total: PropTypes.number,
});

export const LeadersQueryResult = PropTypes.shape({
  nextPage: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  pages: PropTypes.objectOf(PropTypes.arrayOf(CalculatorResult)).isRequired,
});

export const LeadersFilter = PropTypes.shape({
  inputSize: PropTypes.string,
  orderField: PropTypes.string,
  orderDesc: PropTypes.bool,
});
